import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsSystemsPopupOpened,
} from "src/redux/slices/assignBuildingSlice";
import Systems from "./Systems";
import { useTranslation } from "react-i18next";

const ContractPopup = () => {
  const dispatch = useDispatch();
  const { isSystemsPopupOpened } = useSelector(
    (state: any) => state.assignBuilding
  );

  const { t } = useTranslation(["common", "assignBuilding"]);
  const { isNewMode } = useSelector((state: any) => state.assignBuilding);

  
  const handleEditProfile = () => {
    dispatch(setIsSystemsPopupOpened(false) as any);
  };
  return (
    <Dialog visible={isSystemsPopupOpened} onHide={handleEditProfile} header={isNewMode ? t("newContract"):t("editContract")} headerClassName="popup-header" className="edit-assign-building-popup">
      <Systems />
    </Dialog>
  );
};

export default ContractPopup;
